import { render, staticRenderFns } from "./ControlsTemplate.vue?vue&type=template&id=46fff752&scoped=true&"
import script from "./ControlsTemplate.vue?vue&type=script&lang=ts&"
export * from "./ControlsTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ControlsTemplate.vue?vue&type=style&index=0&id=46fff752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fff752",
  null
  
)

export default component.exports